import React from 'react';
import {
  renderTextField,
  renderCheckbox,
  renderRadioButtonGroup,
} from '../../helpers/renderFormInputs';
import { tumourTypes, isupGrades } from '../../constants';

import {
  cadessCarcinomaExtentValidation,
  cadessPercentageG45Validation,
  cadessCarcinomaLengthValidation,
  cadessGleasonPrimaryValidation,
  cadessGleasonRemainingValidation,
  cadessISUPGradeGroupValidation,
  cadessNbPosCoresValidation,
  cadessTumorTypeValidation,
} from '../../helpers/cadessValidationHelper';


export const histologicalTumorTypeFieldsData = [
  {
    name: 'tumourType',
    component: renderRadioButtonGroup,
    warn: cadessTumorTypeValidation,
    items: [
      {
        value: tumourTypes.NO_PRIMARY_TUMOUR,
        label: 'No evidence of primary tumour',
      },
      {
        value: tumourTypes.ADENOCARCINOMA,
        label: 'Adenocarcinoma (Acinar, usual type)',
      },
      {
        value: tumourTypes.OTHER,
        label: (
          <>
            Other{' '}
            <i>(specify)</i>
          </>
        ),
      },
    ],
  },
  {
    name: 'tumourTypeSpecified',
    multiLine: false,
    component: renderTextField,
  },
];

export const histologicalTumorTypeCaseLevelFieldsData = [
  {
    name: 'tumourType',
    component: renderRadioButtonGroup,
    warn: cadessTumorTypeValidation,
    items: [

      {
        value: tumourTypes.NO_PRIMARY_TUMOUR,
        label: 'No evidence of primary tumour',
      },
      {
        value: tumourTypes.ADENOCARCINOMA,
        label: 'Adenocarcinoma (Acinar, usual type)',
      },
      {
        value: tumourTypes.OTHER,
        label: (
          <>
            Other{' '}
            <i>(specify)</i>
          </>
        ),
      },
    ]
  },
  {
    name: 'tumourTypeSpecified',
    multiLine: false,
    component: renderTextField,
  },
];


export const histologicalGradeFieldsData = [
  // GLEASON SCORE
  {
    name: 'primaryGrade',
    component: renderRadioButtonGroup,
    items: [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
    ],
    warn: cadessGleasonPrimaryValidation,
  },

  {
    name: 'highestRemainingGrade',
    component: renderRadioButtonGroup,
    items: [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
    ],
    warn: cadessGleasonRemainingValidation,
  },

  {
    name: 'specifyGradeIndeterminatedReason',
    component: renderCheckbox,
  },

  {
    name: 'gradeSpecified',
    component: renderTextField,
  },
  // ISUP GRADE GROUP
  {
    name: 'isupGrade',
    component: renderRadioButtonGroup,
    warn: cadessISUPGradeGroupValidation,
    items: [
      {
        value: isupGrades.ISUP_GRADE_1,
        label: 'ISUP Grade (Grade Group) 1 (Gleason score 6)',
      },
      {
        value: isupGrades.ISUP_GRADE_2,
        label: 'ISUP Grade (Grade Group) 2 (Gleason score 3+4=7)',
      },
      {
        value: isupGrades.ISUP_GRADE_3,
        label: 'ISUP Grade (Grade Group) 3 (Gleason score 4+3=7)',
      },
      {
        value: isupGrades.ISUP_GRADE_4,
        label: 'ISUP Grade (Grade Group) 4 (Gleason score 8)',
      },
      {
        value: isupGrades.ISUP_GRADE_5,
        label: 'ISUP Grade (Grade Group) 5 (Gleason score 9-10)',
      },
      {
        value: 'other',
        label: (
          <>
            Indeterminate{' '}
            <i>(specify reason)</i>
          </>
        ),
      },
    ],
  },
  {
    name: 'isupGradeSpecified',
    component: renderTextField,
    /*  multiLine: true,
     rows: 1,
     rowsMax: 1, */
  },
  // PERCATAGE GLEASON PATTERN

  {
    name: 'percentageGleasonPattern',
    component: renderTextField,
    warn: cadessPercentageG45Validation,
  },
  {
    name: 'specifyGleasonPatternPercentage',
    component: renderCheckbox,
  },
];

export const tumourExtentFieldsData = [
  {
    name: 'tumourExtent1',
    component: renderTextField,
    warn: cadessNbPosCoresValidation,
  },
  {
    name: 'tumourExtent2',
    component: renderTextField,
    warn: cadessCarcinomaLengthValidation,
  },
  {
    name: 'tumourExtent3',
    component: renderTextField,
    warn: cadessCarcinomaExtentValidation,
  },
];

export const presentStatusFieldsData = [
  {
    name: 'perineuralInvasion',
    component: renderRadioButtonGroup,
    items: [
      { value: 'present', label: 'Present' },
      { value: 'not_identified', label: 'Not identified' },
    ],
  },
  {
    name: 'seminalDuctInvasion',
    component: renderRadioButtonGroup,
    items: [
      { value: 'present', label: 'Present' },
      { value: 'not_identified', label: 'Not identified' },
    ],
  },
  {
    name: 'lymphovascularInvasion',
    component: renderRadioButtonGroup,
    items: [
      { value: 'present', label: 'Present' },
      { value: 'not_identified', label: 'Not identified' },
    ],
  },
  {
    name: 'epe',
    component: renderRadioButtonGroup,
    items: [
      { value: 'present', label: 'Present' },
      { value: 'not_identified', label: 'Not identified' },
    ],
  },

  {
    name: 'epeLocationRightBase',
    component: renderCheckbox,
    label: 'Right base',

  },
  {
    name: 'epeLocationRightMid',
    component: renderCheckbox,
    label: 'Right mid',
  },
  {
    name: 'epeLocationRightApex',
    component: renderCheckbox,
    label: 'Right apex',
  },
  {
    name: 'epeLocationLeftBase',
    component: renderCheckbox,
    label: 'Left base',
  },
  {
    name: 'epeLocationLeftMid',
    component: renderCheckbox,
    label: 'Left mid',
  },
  {
    name: 'epeLocationLeftApex',
    component: renderCheckbox,
    label: 'Left apex',
  },
  {
    name: 'specifyEpeLocation',
    component: renderCheckbox,
    label: (
      <>
        Indeterminate {' '}
        <i>(specify reason)</i>
      </>
    )
  },
  {
    name: 'epeLocationSpecified',
    component: renderTextField,
    multiLine: false,
  },


  {
    name: 'intraductalCarcinoma',
    component: renderRadioButtonGroup,
    items: [
      { value: 'present', label: 'Present' },
      { value: 'not_identified', label: 'Not identified' },
    ],
  },
  {
    name: 'coexistentPathology',
    component: renderRadioButtonGroup,
    items: [
      {
        value: 'present',
        label: (<>
          Present{' '}
          <i>(specify)</i>
        </>),
      },
      { value: 'not_identified', label: 'Not identified' },
    ],
  },
  {
    name: 'coexistentPathologySpecified',
    component: renderTextField,
  }
];

export const termsOfAgreementFieldData = {
  name: 'termsAgreement',
  component: renderCheckbox,
  //defaultValue: false,
}


export const fieldsDataSpecimenLevel = [
  ...histologicalTumorTypeFieldsData,
  ...histologicalGradeFieldsData,
  ...tumourExtentFieldsData,
  ...presentStatusFieldsData,
  termsOfAgreementFieldData,
];

export const fieldsDataCaseLevel = [
  ...histologicalTumorTypeCaseLevelFieldsData,
  ...histologicalGradeFieldsData,
  ...tumourExtentFieldsData,
  ...presentStatusFieldsData,
  termsOfAgreementFieldData,
];
